export default __webpack_public_path__ + "static/media/1.35f2216d.jpg";